<h2 mat-dialog-title>Error</h2>
<mat-dialog-content>
  <p>
    {{data.message}}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
</mat-dialog-actions>
